import { render, staticRenderFns } from "./AdminMortgageSettingsClassification.vue?vue&type=template&id=8305e5be&"
import script from "./AdminMortgageSettingsClassification.vue?vue&type=script&lang=js&"
export * from "./AdminMortgageSettingsClassification.vue?vue&type=script&lang=js&"
import style0 from "./AdminMortgageSettingsClassification.vue?vue&type=style&index=0&id=8305e5be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports